import React from "react";
import { useTranslate } from "@refinedev/core";
import {
  UserOutlined,
  TeamOutlined,
  UserSwitchOutlined,
  ApiOutlined,
  ThunderboltOutlined,
  ExperimentOutlined,
} from "@ant-design/icons";
import { TabHub } from "../../../components/TabHub";
import { UserList } from "../../users/list";
import { UserGroupList } from "../../user-groups/list";
import { AssignmentRulesList } from "../../assignment-rules";
import { ServiceProviderList } from "../../service-providers";
import { AutomationTaskList } from "../../automation-tasks";
import { AutomationPage } from "../../automation";
import { useSuperAdmin } from "../../../hooks/auth";

/**
 * Flux de production hub — who can act, and how work gets routed and processed.
 *
 * The automation testbed is a technical console rather than configuration, so
 * it is superadmin-only and sits last, behind an explicit "Banc d'essai" label.
 */
export const WorkflowConfigurationPage: React.FC = () => {
  const _t = useTranslate();
  const isSuperAdmin = useSuperAdmin();

  const items = [
    {
      key: "users",
      label: _t("configuration.workflowTabs.users", "Users"),
      icon: <UserOutlined />,
            children: <UserList hideHeader staffOnly />,
    },
    {
      key: "groups",
      label: _t("configuration.workflowTabs.groups", "Groups"),
      icon: <TeamOutlined />,
      children: <UserGroupList hideHeader />,
    },
    {
      key: "providers",
      label: _t("configuration.workflowTabs.providers", "Service providers"),
      icon: <ApiOutlined />,
      children: <ServiceProviderList hideHeader />,
    },
    {
      key: "assignment",
      label: _t("configuration.workflowTabs.assignment", "Assignment rules"),
      icon: <UserSwitchOutlined />,
      children: <AssignmentRulesList hideHeader />,
    },/*
    {
      key: "automation",
      label: _t("configuration.workflowTabs.automation", "Automation"),
      icon: <ThunderboltOutlined />,
      children: <AutomationTaskList hideHeader />,
    },*/
  ];

  if (isSuperAdmin) {
    items.push({
      key: "testbed",
      label: _t("configuration.workflowTabs.testbed", "Testbed"),
      icon: <ExperimentOutlined />,
      children: <AutomationPage />,
    });
  }

  return (
    <div className="max-w-7xl mx-auto">
      <TabHub
        title={_t("configuration.workflow", "Production workflow")}
        subtitle={_t("configuration.workflowSubtitle", "")}
        items={items}
      />
    </div>
  );
};
